import { gql } from '@apollo/client';

export const FILTERED_SUBJECT_REPORTS = gql`
  query FilteredSubjectReports($input: SearchData!) {
    subjectReports: filteredSubjectReports(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          averageMark
          class
          emisNumber
          level1
          level2
          level3
          level4
          level5
          level6
          level7
          numberAbsent
          numberEnrolled
          numberWrote
          passRate
          term
          year

          cluster {
            id
            name
          }
          circuit {
            id
            name
          }
          district {
            id
            name
          }
          grade {
            id
            value
          }
          institution {
            id
            name
          }
          promotionStatus {
            id
            name
          }
          province {
            id
            name
          }
          region {
            id
            name
          }
          subject {
            id
            name
          }
        }
      }
    }
  }
`;
